import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';

Vue.use(Vuex);

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
  reducer: (state) => ({
    userData: state.userData, // 存入localStorage的值
    showLog: state.showLog
  }),
});

export default new Vuex.Store({
  state: {
    userData: {},
    showLog: 0
  },
  mutations: {
    // 客户基础数据
    setUserData(state, data) {
      state.userData = data;
    },
    setShowLog(state, data) {   
      state.showLog = data;
    }
  },
  actions: {},
  modules: {},
  plugins: [vuexLocal.plugin],
});